module.exports = __webpack_public_path__ + "static/media/pool.d7971389.svg";